import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, CircularProgress, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ElementDescription from '../common/ElementDescription';
import ElementalDashboard from '../common/ElementalDashboard';
import { useDataProvider } from "react-admin";
import InformationCard from '../common/InformationCard';
import quadrants from '../../resources/quadrants';
import NotesGroup from '../common/NotesGroup';
import AllCategoriesBarChart from '../common/AllCategoriesBarChart';
import NotesIterator from '../common/NotesIterator';
import { Loading } from "ra-ui-materialui";
import zIndex from '@mui/material/styles/zIndex';
import { HtmlTooltip } from '../common/HtmlTooltip';
import { getCategoryLabel } from '../../utils/getCategoryLabel';
import { getCategoryImage } from '../../utils/getCategoryImage';
import { calculateAvgHealthPercentage } from '../../utils/calculateAvgHealthPercentage';
import { ItemLoader } from '../ui/ItemLoader';
const categoryState = []

const drawerWidth = '50%';
const drawerMinWidth = 656;

const useStyles = makeStyles()((theme) => ({
  root: {
    width: drawerWidth,
    minWidth: drawerMinWidth,
    flexShrink: 0,
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth})`,
    minWidth: `calc(100% - ${drawerMinWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  lifeCategoryHeader: {
    borderBottom: '1px solid #E2E2E2',
    padding: '12px 24px',
  },
  header: {
    flexGrow: 1,
    fontWeight: 'bold',
  },
  title: {
    color: '#003E6F',
    fontSize: '24px',
  },
  subtitle: {
    fontSize: '18px',
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    width: drawerWidth,
    // minWidth: drawerMinWidth,
    right: '50%',
    // width: '100%',
    boxShadow: 'none',
    overflow: 'auto',
    // [theme.breakpoints.down('xl')]: {
    //   width: '100%',
    //   minWidth: '100%',
    // },
  },
  lifeCategory: {
    justifyContent: 'flex-start',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '0%',
    overflow: 'auto',
    transition: '0.3s',

    height: '100%',
    background: 'white',
    zIndex: 1000,
    transform: 'translateX(-100%)',

    [theme.breakpoints.down('xl')]: {
      transform: 'translateX(0%)',
    },
  },
  lifeCategory_open: {
    width: '100%',


  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  closeButton: {
    padding: 0,
    display: 'flex',
    gap: '12px',
    fontSize: '12px',
    alignItems: 'center',
  },
  category: {
    display: 'flex',
    justifyContent: 'start',
    gap: '12px',
    marginLeft: 'auto',
    fontSize: '16px',
    flexDirection: 'column',
    padding: '16px 24px',
    fontWeight: '600',
  },
  category_percentage_wrapper: {
    width: '100%',
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    height: '10px',
  },
  category_percentage: {
    height: '10px',
    width: '100%',
    borderRadius: '4px',
    backgroundColor: '#cccccc',
    position: 'relative',
  },
  category_percentage_main: {
    height: '10px',
    borderRadius: '4px',
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: '0px',
    background: 'black'
  },
  category_percentage_number: {
    position: 'relative',
    fontSize: '20px',
    fontWeight: '600',
    bottom: '16px'

  },
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    padding: '0 24px',
    gap: '16px',
    overflow: 'hidden',
    marginTop: '24px',
  },
  zone: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    // padding: '16px 24px',
    // fontWeight: '600',
  },
  zone_title: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#EE613F',
  },
  zone_text: {
    fontSize: '14px',
    color: '#667085',
  },
  elements: {
    padding: '16px',
    border: '1px solid #E2E2E2',
    borderRadius: '8px',
    height: 'fit-content'
  },
  elements_title_box: {
    marginBottom: '20px',
    fontSize: '13px',
    color: '#667085',
    fontWeight: '500',
    span: {
      color: '#000',
      textTransform: 'capitalize',
    },
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px'
  },
  elements_title_percentage: {
    fontSize: '13px',
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600'

  },
  gauge: {
    display: 'flex',
    gap: '12px',
    padding: '4px 8px',
    fontSize: '10px',
    fontWeight: '600',
    color: '#667085',
    alignItems: 'center',
    marginBottom: '16px',
    // cursor: 'pointer',
  },
  gauge_label: {
    flexGrow: '1',
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '10px',
    fontWeight: '600',
    color: '#232323',
  },
  gauge_label_red: {
    color: '#FF551C',
  },
  gauge_scale: {
    width: '100%',
    position: 'relative',
    height: '5.5px',
    borderRadius: '5px',
    backgroundColor: '#F3F3F3',

    img: {
      position: 'absolute',
      top: '0px',
      bottom: '0px',
      left: '0px',
      borderRadius: '5px',
      height: '5.5px',
    }
  },
  notes: {
    padding: '24px',
  },
  bottomContent: {
    '& > *': {
      width: '50%',
      textAlign: 'justify',

      '&:nth-of-type(n+2)': {
        // marginLeft: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        borderLeft: `1px solid ${theme.colors.gallery}`,
      },
    }
  },
  allCategoriesBarChart: {
    // minWidth: theme.spacing(50),
    width: '100%',

    [theme.breakpoints.up('xl')]: {
      margin: '0 32px',
      padding: '0',
    },
  },
  '@media (min-width: 1024px)': {
    appBarShift: {
      marginRight: drawerMinWidth,
    },
    content: {
      marginRight: -drawerMinWidth,
    },
  },
  categoryInfo: {
    color: theme.colors.shark,
    fontWeight: 'bold',
  },
  informationCard: {
    [theme.breakpoints.down('xl')]: {
      padding: '0'
    },
  },
  none: {
    display: 'none',
  }
}));

export default function CapabilityCompareLevelDrawer({
  open, assessmentId, category, categoryName, quadrant, userName, categoryLevel, coachNotes, lifeJournal,
  handleDrawerClose, handleCoachNotesUpdate, handleLifeJournalUpdate, elementName, getColor, categoryDetails,
  assessmentId1, assessmentId2, element2, element1,
}) {
  const { classes } = useStyles();
  const dataProvider = useDataProvider();
  const elementNameRef = useRef();
  elementNameRef.current = elementName;
  const [isLoading, setIsLoading] = useState(true);
  const [dimensionResult, setDimensionResult] = useState({
    assessmentId1: {},
    assessmentId2: {}
  });
  const [isAnimatedComplete, setIsAnimatedComplete] = useState(false)
  useEffect(() => {
    setIsAnimatedComplete(false)
    setTimeout(() => { setIsAnimatedComplete(true) }, 300)

  }, [open]);
  useEffect(() => {
    setIsLoading(true)
    async function fetchData() {

      try {
        const { data: res1 } = await dataProvider.getOne(`assessments/${assessmentId1}/categories/${category}/element`, { id: elementName });
        const { data: res2 } = await dataProvider.getOne(`assessments/${assessmentId2}/categories/${category}/element`, { id: elementName });
        setDimensionResult({
          assessmentId1: res1.dimension_result,
          assessmentId2: res2.dimension_result
        })
        setIsLoading(false)
      } catch (e) {
      }
    }
    fetchData();
  }, [assessmentId1, assessmentId2, category, dataProvider, elementName]);

  const healthPercentage1 = calculateAvgHealthPercentage(dimensionResult.assessmentId1);
  const healthPercentage2 = calculateAvgHealthPercentage(dimensionResult.assessmentId2);

  return (
    <Box
      className={`${classes.lifeCategory} ${open ? classes.lifeCategory_open : null}`}
    >

      {open && isAnimatedComplete && <>
        <Box
          className={classes.lifeCategoryHeader}
          display="flex"
          alignItems="center"
        >
          <Box
            className={classes.header}
          >
            <Box
              className={classes.title}
            >
              Category Details

              4
            </Box>
          </Box>
          <IconButton
            onClick={handleDrawerClose}
            className={classes.closeButton}
          >
            Close
            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.589844 11.09L5.16984 6.5L0.589844 1.91L1.99984 0.5L7.99984 6.5L1.99984 12.5L0.589844 11.09Z" fill="#003E6F" />
            </svg>
          </IconButton>
        </Box>
        <Box
          className={classes.info}
        >
          <Box className={classes.elements}>
            <Box className={classes.elements_title_box}>
              Elements
              <HtmlTooltip placement="left" title={
                <Box style={{ width: '224px' }}>
                  <b>
                    INSTRUCTION
                  </b>
                  <Typography color="inherit">
                    Click on the gauges below to receive deeper insight and guided direction.
                  </Typography>

                </Box>
              }>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2820_6794)">
                    <path d="M8.25 5.25H9.75V6.75H8.25V5.25ZM8.25 8.25H9.75V12.75H8.25V8.25ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z" fill="#667085" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2820_6794">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>


              </HtmlTooltip>


            </Box>
            <Box
              className={`${classes.gauge}`}
            >
              <img height={16} width={16} src={getCategoryImage(element1.name)} />
              <Box
                className={classes.gauge_label}

              >
                {getCategoryLabel(element1?.name)}

                <Box className={classes.gauge_scale}>
                  <img src={`/${getColor(element1.scale)}_back.jpg`} style={{ width: '100%' }} alt='' />
                  <img
                    src={`/${getColor(element1.scale)}.jpg`}
                    className={classes.gauge_scale_main}
                    style={{ width: `${element1.scale * 10}%` }}
                    alt=''
                  />

                </Box>
              </Box>
              {element1.scale * 10}%
            </Box>

          </Box>
          <Box className={classes.elements}>
            <Box className={classes.elements_title_box}>
              Elements
              <HtmlTooltip placement="left" title={
                <Box style={{ width: '224px' }}>
                  <b>
                    INSTRUCTION
                  </b>
                  <Typography color="inherit">
                    Click on the gauges below to receive deeper insight and guided direction.
                  </Typography>

                </Box>
              }>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2820_6794)">
                    <path d="M8.25 5.25H9.75V6.75H8.25V5.25ZM8.25 8.25H9.75V12.75H8.25V8.25ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z" fill="#667085" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2820_6794">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>


              </HtmlTooltip>


            </Box>
            <Box
              className={`${classes.gauge}`}
            >
              <img height={16} width={16} src={getCategoryImage(element2.name)} />
              <Box
                className={classes.gauge_label}

              >
                {getCategoryLabel(element2?.name)}

                <Box className={classes.gauge_scale}>
                  <img src={`/${getColor(element2.scale)}_back.jpg`} style={{ width: '100%' }} alt='' />
                  <img
                    src={`/${getColor(element2.scale)}.jpg`}
                    className={classes.gauge_scale_main}
                    style={{ width: `${element2.scale * 10}%` }}
                    alt=''
                  />

                </Box>
              </Box>
              {element2.scale * 10}%
            </Box>

          </Box>

          {isLoading ? <ItemLoader /> : <Box className={classes.elements}>
            <Box className={classes.elements_title_box}>
              <Box><span>Average {elementName}</span> across all life categories</Box>
              <Box className={classes.elements_title_percentage}>
                {healthPercentage1}%


              </Box>

            </Box>
            {
              Object.entries(dimensionResult.assessmentId1).map(([key, element], index) => {
                const color = getColor(element.value)
                return (
                  <Box
                    className={`${classes.gauge}`}
                    key={index}
                  >
                    <Box
                      className={`${classes.gauge_label} ${key === category && classes.gauge_label_red}`}

                    >
                      {element.name}

                      <Box className={classes.gauge_scale}>
                        {key === category ? <>
                          <img src={`/${color}_back.jpg`} style={{ width: '100%' }} alt='' />
                          <img
                            src={`/${color}.jpg`}
                            className={classes.gauge_scale_main}
                            style={{ width: `${element.value * 10}%` }}
                            alt=''
                          />
                        </> : <img
                          src={`/${color}.jpg`}
                          className={classes.gauge_scale_main}
                          style={{ width: `${element.value * 10}%` }}
                          alt=''
                        />}
                        {/* <Box style={{ background: color }}>
                            </Box> */}
                      </Box>
                    </Box>
                    {element.value * 10}%
                  </Box>
                )
              })
            }
          </Box>}

          {isLoading ? <ItemLoader /> :
            <Box className={classes.elements}>
              <Box className={classes.elements_title_box}>
                <Box><span>Average {elementName}</span> across all life categories</Box>
                <Box className={classes.elements_title_percentage}>
                  {healthPercentage2}%


                </Box>

              </Box>
              {
                Object.entries(dimensionResult.assessmentId2).map(([key, element], index) => {
                  const color = getColor(element.value)
                  return (
                    <Box
                      className={`${classes.gauge}`}
                      key={index}
                    >
                      <Box
                        className={`${classes.gauge_label} ${key === category && classes.gauge_label_red}`}

                      >
                        {element.name}

                        <Box className={classes.gauge_scale}>
                          {key === category ? <>
                            <img src={`/${color}_back.jpg`} style={{ width: '100%' }} alt='' />
                            <img
                              src={`/${color}.jpg`}
                              className={classes.gauge_scale_main}
                              style={{ width: `${element.value * 10}%` }}
                              alt=''
                            />
                          </> : <img
                            src={`/${color}.jpg`}
                            className={classes.gauge_scale_main}
                            style={{ width: `${element.value * 10}%` }}
                            alt=''
                          />}
                          {/* <Box style={{ background: color }}>
                            </Box> */}
                        </Box>
                      </Box>
                      {element.value * 10}%
                    </Box>
                  )
                })
              }
            </Box>
          }

        </Box>
      </>}
    </Box>
  );
}